import { render, staticRenderFns } from "./LDH.vue?vue&type=template&id=5d402a6f&scoped=true&"
import script from "./LDH.vue?vue&type=script&lang=js&"
export * from "./LDH.vue?vue&type=script&lang=js&"
import style0 from "./LDH.vue?vue&type=style&index=0&id=5d402a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d402a6f",
  null
  
)

export default component.exports